<template>
  <div class="bg-static-info-low rounded-sm relative p-24">
    <div class="relative z-10">
      <div class="heading-3 mb-8">{{ i18n(translations.liveWallet) }}</div>
      <div class="body-2 mb-16">
        {{ i18n(translations.liveWalletInfoText) }}
      </div>
      <div v-if="hasWalletBalance" class="space-y-16">
        <div
          v-for="(amount, currency) in info"
          :key="currency"
          class="bg-static-default-low rounded-sm flex p-8"
        >
          <div class="body-1">{{ i18n.currencySymbol(currency) }}</div>
          <div class="body-1-bold flex-1 text-right">
            {{ i18n.price({ amount: amount!, currency }, { symbol: false }) }}
          </div>
        </div>
      </div>
      <div
        v-if="!hasWalletBalance"
        class="bg-static-default-low rounded-sm body-1-bold flex p-8"
      >
        {{ i18n(translations.noWalletBalance) }}
      </div>
    </div>
    <IconMoney
      class="text-static-brand-hi absolute right-16 top-8 z-0 h-[130px] w-[130px] rotate-12 opacity-[0.15]"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { GetSellerWallet } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconMoney } from '@ds/icons/IconMoney'

import translations from './LiveWallet.translations'

const props = defineProps<{
  info: GetSellerWallet['live_wallet']
}>()

const i18n = useI18n()

const hasWalletBalance = computed(() => !!Object.keys(props.info).length)
</script>
